import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import ProductNav from './ProductNav'
import Contact from './Contact'
import Product from './Product'
import Product_old from './Product_old';
import * as c from '../utils/constants';
import Airlock from '../images/rotaryAirlock.png'
import Horizon from '../images/horizon.png';
import Prater from '../images/prater.png';
import TecWeigh from '../images/Tecweigh-logo.jpg';
import ProductSeperator from '../images/productseperator.png';
import Sidewinder from '../images/sidewinder.png';
import VentfilterSFT from '../images/ventfilersft.png';
import VentfilterSFTC from '../images/ventfiltersftc.png';
import PressureBlower from '../images/pressureblower.png';
import FilterReceiver from '../images/filterReceiver.png';
import BeltFeeder from '../images/twweightbelftfeeder.png';
import VolumeFeeder from '../images/twvolumetric.png';
import BletScale from '../images/twbeltscale.png';
import Conditioner from '../images/BBConditioner.png';
import Discharger from '../images/BBDrumdischarge.png';
import Filler from '../images/BBFiller.png';
import HammerMill from '../images/hammermill.png';
import MegaMill from '../images/megamill.png';
import AirClassifyer from '../images/airclassifier.png';
import AirClassMill from '../images/praterairclassifyigmill.png';
import LumpFlake from '../images/lumpflakebreaker.png';
import Sifter from '../images/sifter.png';
import FineGrind from '../images/finegrindingmills.png';
import LineCardprev from '../images/lineCardprev.png'
import LineCardprev2 from '../images/lineCardprev.png'
import Manufacturers from './Manufacturers';
import MaterialT from '../images/materialTransfer.png'
















class AllProducts extends React.Component{


    render(){
        return (
            <BrowserRouter basename="/#/AllProducts">
            <div className="row prodpage">
                <div className="col-xl-2 col-lg-3 col-md-12 col-sm-12" >
                    <ProductNav />
                </div>
                <div className = "col-xl-10 col-lg-9 col-md-12 col-sm-12 prodback">
                    <Switch>
                        <Route exact path = "/" render = {()=> 
                            <Manufacturers/>}
                        />
                        <Route exact path = "/AirLock" render = {()=> 
                            <Product 
                                image={Airlock} 
                                description={c.airlockHS.description}
                                header={c.airlockHS.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/VentFilterSFTC" render = {()=> 
                            <Product 
                                image={VentfilterSFTC}
                                description={c.ventFilterSFTC.description}
                                header={c.ventFilterSFTC.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/VentFilterSFT" render = {()=> 
                            <Product 
                                image={VentfilterSFT} 
                                description={c.ventFilterSFT.description}
                                header={c.ventFilterSFT.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/FilterReceiver" render = {()=> 
                            <Product 
                                image={FilterReceiver} 
                                description={c.filterReceiver.description}
                                header={c.filterReceiver.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/PressureBlower" render = {()=> 
                            <Product 
                                image={PressureBlower} 
                                description={c.pressureBlower.description}
                                header={c.pressureBlower.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/Sidewinder" render = {()=> 
                            <Product 
                                image={Sidewinder} 
                                description={c.sidewinder.description}
                                header={c.sidewinder.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/ProductSeperator" render = {()=> 
                            <Product 
                                image={ProductSeperator} 
                                description={c.productSeperator.description}
                                header={c.productSeperator.header}
                                logo={Horizon}/>
                            } 
                        />
                        <Route exact path = "/BulkBagFill" render = {()=> 
                            <Product 
                                image={Filler} 
                                description={c.bulkbagfiller.description}
                                header={c.bulkbagfiller.header}
                                logo={MaterialT}/>
                            } 
                        />
                        <Route exact path = "/BulkBagCondition" render = {()=> 
                            <Product 
                                image={Conditioner} 
                                description={c.bulkbagconditioner.description}
                                header={c.bulkbagconditioner.header}
                                logo={MaterialT}/>
                            } 
                        />
                        <Route exact path = "/BulkBagDischarge" render = {()=> 
                            <Product 
                                image={Discharger} 
                                description={c.bulkbagdischarge.description}
                                header={c.bulkbagdischarge.header}
                                logo={MaterialT}/>
                            } 
                        />
                        <Route exact path = "/BeltScales" render = {()=> 
                            <Product 
                                image={BletScale} 
                                description={c.beltscales.description}
                                header={c.beltscales.header}
                                logo={TecWeigh}/>
                            } 
                        />
                        <Route exact path = "/BeltFeeders" render = {()=> 
                            <Product 
                                image={BeltFeeder} 
                                description={c.beltfeeder.description}
                                header={c.beltfeeder.header}
                                logo={TecWeigh}/>
                            } 
                        />
                        <Route exact path = "/VolumetricFeeders" render = {()=> 
                            <Product 
                                image={VolumeFeeder} 
                                description={c.volumefeeder.description}
                                header={c.volumefeeder.header}
                                logo={TecWeigh}/>
                            } 
                        />
                        <Route exact path = "/AirClassifiers" render = {()=> 
                            <Product 
                                image={AirClassifyer} 
                                description={c.airclass.description}
                                header={c.airclass.header}
                                logo={Prater}/>
                            } 
                        />
                        {/* <Route exact path = "/AirClassifyingMills" render = {()=> 
                            <Product 
                                image={AirClassMill} 
                                description={c.airclassmill.description}
                                header={c.airclassmill.header}
                                logo={Prater}/>
                            } 
                        /> */}
                        <Route exact path = "/HammerMills" render = {()=> 
                            <Product 
                                image={HammerMill} 
                                description={c.hammermill.description}
                                header={c.hammermill.header}
                                logo={Prater}/>
                            } 
                        />
                        <Route exact path = "/MegaMills" render = {()=> 
                            <Product 
                                image={MegaMill} 
                                description={c.megamill.description}
                                header={c.megamill.header}
                                logo={Prater}/>
                            } 
                        />
                        <Route exact path = "/FineGrinder" render = {()=> 
                            <Product 
                                image={FineGrind} 
                                description={c.finegrindmill.description}
                                header={c.finegrindmill.header}
                                logo={Prater}/>
                            } 
                        />
                        <Route exact path = "/LumpFlakeBreaker" render = {()=> 
                            <Product 
                                image={LumpFlake} 
                                description={c.lumflakebreaker.description}
                                header={c.lumflakebreaker.header}
                                logo={Prater}/>
                            } 
                        />
                        <Route exact path = "/CentrifugalSifter" render = {()=> 
                            <Product 
                                image={Sifter} 
                                description={c.sifter.description}
                                header={c.sifter.header}
                                logo={Prater}/>
                            } 
                        />
                        <Route exact path = "/Contact" render = {()=> <Contact />} />
                    </Switch>
                </div>
            </div>
            </BrowserRouter>
        )
    }
}

export default AllProducts;